import React, { useEffect, useState } from "react";
import {
  Modal,
  Typography,
  Avatar,
  Tag,
  Divider,
  Row,
  Col,
  Space,
  List,
} from "antd";
import { UserOutlined, TeamOutlined, CrownOutlined } from "@ant-design/icons";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";

const { Title, Text, Paragraph } = Typography;

const ORANGE = "#e2700d";

const ViewGroup = ({ open, onClose, groupId }) => {
  // if (!group) return null;
  const { request } = useRequest();
  const [groupData, setGroupData] = useState({});
  const fetchGroup = (id) => {
    request({
      url: `${apiPath.listGroup}/${id}`,
      method: "GET",
      onSuccess: (res) => {
        setGroupData(res.data);
      },
    });
  };

  useEffect(() => {
    fetchGroup(groupId);
  }, [groupId]);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={700}
      bodyStyle={{ background: "#fff", padding: 24 }}
      closeIcon={<span style={{ color: ORANGE, fontSize: 18 }}>×</span>}
    >
      {/* 🔹 HEADER */}
      <Row gutter={16} align="middle">
        <Col>
          <Avatar size={64} src={groupData.image} icon={<TeamOutlined />} />
        </Col>
        <Col flex="auto">
          <Title level={4} style={{ marginBottom: 0 }}>
            {groupData.name}
          </Title>
          <Text type="secondary">{groupData.region}</Text>
        </Col>
        <Col>
          <Tag color={groupData.status === "APPROVED" ? "green" : "orange"}>
            {groupData.status}
          </Tag>
        </Col>
      </Row>

      <Divider />

      {/* 🔹 DESCRIPTION */}
      {groupData.description && <Paragraph>{groupData.description}</Paragraph>}

      {/* 🔹 STATS */}
      <Row gutter={24} style={{ marginBottom: 16 }}>
        <Col>
          <Text>
            <TeamOutlined /> Members:{" "}
            <b>{groupData.membersDetails?.length || 0}</b>
          </Text>
        </Col>
        <Col>
          <Text>
            <CrownOutlined /> Admins:{" "}
            <b>{groupData.adminsDetails?.length || 0}</b>
          </Text>
        </Col>
        <Col>
          <Text>
            Posts: <b>{groupData?.totalPosts || 0}</b>
          </Text>
        </Col>
      </Row>

      {/* 🔹 ADMINS */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        Admins
      </Divider>

      <List
        dataSource={groupData.adminsDetails || []}
        locale={{ emptyText: "No admins" }}
        renderItem={(admin) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={admin.avatar} icon={<UserOutlined />} />}
              title={admin.name}
              description={
                <>
                  <div>{admin.email}</div>
                  <div>{admin.phone || "-"}</div>
                </>
              }
            />
          </List.Item>
        )}
      />

      {/* 🔹 MEMBERS */}
      <Divider orientation="left" style={{ color: ORANGE }}>
        Members
      </Divider>

      <List
        dataSource={groupData.membersDetails || []}
        locale={{ emptyText: "No members" }}
        renderItem={(member) => (
          <List.Item>
            <List.Item.Meta
              avatar={<Avatar src={member.avatar} icon={<UserOutlined />} />}
              title={member.name}
              description={
                <>
                  <div>{member.email}</div>
                  <div>{member.phone || "-"}</div>
                </>
              }
            />
          </List.Item>
        )}
      />

      {/* 🔹 DATES */}
      <Divider />
      <Text type="secondary" style={{ fontSize: 12 }}>
        Created: {moment(groupData.createdAt).format("DD MMM YYYY, hh:mm A")}
        <br />
        Updated: {moment(groupData.updatedAt).format("DD MMM YYYY, hh:mm A")}
      </Text>
    </Modal>
  );
};

export default ViewGroup;
